export default __webpack_public_path__ + "static/media/mob_preland_5.0fbe59a3.jpg";